<template>
    <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="744px"
        :center="true"
        :top="top"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="cancelCreate"
    >
        <!-- 施工单位名称 -->
        <div class="item">
            <div class="item-title">施工单位名称<img src="../../../assets/iconFolder/common/common_important_icon.png" alt=""></div>
            <input v-model="unitObject.name" type="text" placeholder="请填写施工单位名称">
        </div>
        <!-- 所属地震局 -->
        <div class="item" v-if="!isProvinceUnit">
            <div class="item-title">所属地震局<img src="../../../assets/iconFolder/common/common_important_icon.png" alt=""></div>
            <el-select v-model="unitObject.earthquakeUnit" placeholder="选择地震局" :disabled="unitObject.id">
                <el-option
                v-for="item in earthquakeUnitArray"
                :key="item.id"
                :label="item.username"
                :value="item.id">
                </el-option>
            </el-select>
        </div>
        <!-- 单位负责人 -->
        <div class="item">
            <div class="item-title">单位负责人<img src="../../../assets/iconFolder/common/common_important_icon.png" alt=""></div>
            <input v-model="unitObject.principal" type="text" placeholder="请填写施工单位负责人">
        </div>
        <!-- 联系方式 -->
        <div class="item">
            <div class="item-title">手机号<img src="../../../assets/iconFolder/common/common_important_icon.png" alt=""></div>
            <input v-model="unitObject.mobile" type="text" placeholder="请填写负责人手机号">
        </div>
        <!-- 导入钻探任务 -->
        <!-- <div class="item" v-show="!unitObject.id"> -->
            <!-- 上方标题 -->
            <!-- <div class="item-upload">
                <p class="item-title">导入钻探任务<img src="../../../assets/iconFolder/common/common_important_icon.png" alt=""></p>
                <div class="item-upload-example">
                    <span>下载模板</span>
                </div>
            </div> -->
            <!-- 上传 -->
            <!-- <div v-if="!uploadFile.url" class="upload-div">
                <img src="../../../assets/iconFolder/common/common_select_file.png" alt="">
                <span>点击上传或将文件直接拖到此处上传</span>
                <input class="file-ele" type="file" accesskey=".zip" @change="selectedFile">
            </div> -->
            <!-- 上传完成 -->
            <!-- <div v-else class="upload-file"> -->
                <!-- 上传后 -->
                <!-- <div class="upload-file-name">
                    <img src="../../../assets/iconFolder/common/common_file_icon.png" alt="">
                    <span>{{ uploadFile.fileName }}</span>
                </div> -->
                <!-- 删除按钮 -->
                <!-- <button @click="deleteFileAction" style="{ border: none; background: none; box-shadow: none; }">
                    <img src="../../../assets/iconFolder/common/common_delete_file.png" alt="">
                </button>
            </div>
        </div> -->
        <!-- 按钮 -->
        <div class="button-div">
            <button @click="cancelCreate" class="cancel">取消</button>
            <button @click="confirmAdd" class="confirm">确定</button>
        </div>
    </el-dialog>
</template>
<script>
import { saveAs } from "file-saver";
import { CreateUnit, UpdateUnitList, GetEarthquakeUnit } from '@/http/api/api-hb'
export default {
    data() {
        return {
            // 距离上方距离
            top: '8vh',
            // 标题
            title: '添加施工单位',
            // 弹窗是否显示
            dialogVisible: false,
            // 施工单位对象
            unitObject: {
                id: null,
                name: null,
                earthquakeUnit: null,
                principal: null,
                mobile: null
            },
            earthquakeUnitArray: [],
            // 上传文件
            uploadFile: {
                file: null,
                fileName: null,
                url: null,
                filePath: null
            },
            // 是否是省局
            isProvinceUnit: false,
            // 省局id
            provinceUnitId: 0
        }
    },
    mounted() {
        const user = JSON.parse(localStorage.getItem('user'))
        if (user.role == 1) {
            this.isProvinceUnit = true
            this.provinceUnitId = user.id
        }
    },
    methods: {
        // 显示弹窗
        showCreateConsUnit(unitObject) {
            console.log(unitObject);
            this.dialogVisible = true
            if (unitObject) {
                this.top = '15vh'
                this.title = '编辑施工单位信息',
                this.unitObject.id = unitObject.id
                this.unitObject.name = unitObject.deptName
                this.unitObject.principal = unitObject.username
                this.unitObject.mobile = unitObject.mobile
            }
            this.requestEarthquakeUnitList()
        },
        // 取消创建
        cancelCreate() {
            this.dialogVisible = false
            this.unitObject = {
                id: null,
                name: null,
                earthquakeUnit: null,
                principal: null,
                mobile: null
            }
            this.uploadFile = {
                file: null,
                fileName: null,
                url: null,
                filePath: null
            }
        },
        // 确认创建
        confirmAdd() {
            if (!this.unitObject.name || this.unitObject.name.length == 0) {
                this.$message.warning('请输入施工单位名称')
                return
            }
            if (!this.unitObject.principal || this.unitObject.principal.length == 0) {
                this.$message.warning('请输入施工单位负责人')
                return
            }
            if (!this.unitObject.mobile || this.unitObject.mobile.length == 0) {
                this.$message.warning('请输入负责人手机号')
                return
            }
            if (this.unitObject.mobile.length != 11) {
                this.$message.warning('请输入正确的手机号')
                return
            }
            if (!this.isProvinceUnit && !this.unitObject.earthquakeUnit) {
                this.$message.warning('请选择所属地震局')
                return
            }
            const params = {
                deptName: this.unitObject.name,
                username: this.unitObject.principal,
                mobile: this.unitObject.mobile,
                pid: 0, // 创建施工单位
                eid: this.unitObject.earthquakeUnit, // 地震局
            }
            if (this.isProvinceUnit) {
                params.eid = this.provinceUnitId
            } else {
                params.eid = this.unitObject.earthquakeUnit
            }
            if (this.unitObject.id) { // 修改
                params.id = this.unitObject.id
                UpdateUnitList(params).then(res => {
                    if (res.code == 200) {
                        this.$message.success('修改成功');
                        this.cancelCreate()
                        this.$emit('updateUnitList')
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
            } else { // 新建
                CreateUnit(params).then(res => {
                    if (res.code == 200) {
                        // 生成blob文本
                        let blobString = '账号：' + this.unitObject.mobile + '\n密码：' + res.data.password
                        const blob = new Blob([blobString], {
                            type: "text/plain;charset=utf-8",
                        });
                        const filename = this.unitObject.principal + '密码.txt'
                        saveAs(blob, filename);

                        this.$message.success('添加成功');
                        this.cancelCreate()
                        this.$emit('updateUnitList')
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
            }
        },
        // 文件选择变化
        selectedFile(e) {
            console.log(e.target.files[0]);
            this.uploadFile.file = e.target.files[0]
            this.uploadFile.fileName = e.target.files[0].name
            this.uploadPictureFile()
        },
        // 上传文件
        uploadPictureFile() {

        },
        // 删除文件
        deleteFileAction() {

        },
        // 获取地震局列表
        requestEarthquakeUnitList() {
            const params = {
                role: 1,
                deptId: this.unitObject.id ? this.unitObject.id : 0
            }
            GetEarthquakeUnit(params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.earthquakeUnitArray = res.data
                    if (this.unitObject.id) {
                        this.earthquakeUnitArray.filter(item => {
                            if (item.self) {
                                this.unitObject.earthquakeUnit = item.id
                            }
                            return item
                        })
                    }
                } else {
                    this.$message.warning(res.msg)
                }
            })
        }
    },
    watch: {
        'unitObject.mobile'(newValue) {
            console.log(newValue);
            if (newValue > 11) {
                this.unitObject.mobile = newValue.slice(0, 11);
            }
        },
    },
}
</script>
<style scoped>
    @import url(../../../assets/css/dialog_button_div.css);
    ::v-deep .el-dialog {
        border-radius: 10px;
    }
    ::v-deep .el-dialog--center .el-dialog__body {
        padding: 0 64px 30px;
        /* background-color: #ff0000; */
    }
    ::v-deep .el-dialog__title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
    }
    .item {
        margin-bottom: 20px;
    }
    .item .item-title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
    }
    .item input {
        width: calc(100% - 24px);
        height: 40px;
        background: #F9F9F9;
        border-radius: 10px;
        border: 2px solid #CCCCCC;
        color: #181818;
        font-size: 16px;
        padding: 0 12px;
        margin-top: 8px;
    }
    .item input:focus {
        outline: none;
    }
    /* 选择框 */
    .item /deep/ .el-select {
        margin-top: 8px;
        width: 100%;
        height: 40px;
        background: #F9F9F9;
    }
    .item /deep/ .el-select .el-input__inner {
        border: none;
        height: 40px;
        background: #F9F9F9;
        border-radius: 10px;
        border: 2px solid #CCCCCC;
        font-size: 16px;
        color: #181818;
    }
    .item /deep/ .el-select .el-input.is-focus .el-input__inner {
        border-radius: 10px;
        border: 2px solid #CCCCCC;
    }
    /* 上传 */
    .item .item-upload {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .item .item-upload .title {
        margin: 0 0 8px 0;
    }
    .item .item-upload .item-upload-example {
        display: flex;
        align-items: center;
    }
    .item .item-upload .item-upload-example img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
    }
    .item .item-upload .item-upload-example span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #014FD9;
    }
    /* 上传 */
    .item .upload-div {
        width: 100%;
        height: 140px;
        background: #ECF6FF;
        border-radius: 10px;
        opacity: 0.55;
        border: 2px dashed #005BA3;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        position: relative;
        margin-top: 8px;
    }
    .item .upload-div img {
        margin-bottom: 8px;
    }
    /* 上传input */
    .file-ele {
        position: absolute;
        top:0;
        right:0;
        opacity: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
    }
    /* 上传文件后 */
    .item .upload-file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 8px;
    }
    .item .upload-file .upload-file-name {
        color: #181818;
        font-size: 16px;
        display: flex;
        align-items: center;
    }
    .item .upload-file .upload-file-name img {
        width: 16px;
        height: 16px;
        margin-right: 12px;
    }
    
</style>